import SimpleObjectRenderer from './simple';
import { Transform } from '@ancienttech/glass';

export default class ProtagonistRenderer extends SimpleObjectRenderer {
    constructor(context) {
        super(context,
            new Transform()
                .queueFixedScaling(0.05, 0.05, 0.05)
                .queueFixedXRotation(Math.PI/2.0)
                .queueContinuousZRotation(0.0004)
                .queuePropertyTranslation(['positions', 'protagonist']),
            require('../textures/eye.png'),
            require('../objects/protagonist.obj')
        );
    }
}